import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ValidationMessageList from '../../../validation/component/ValidationMessageList'
import LabelInput from '../../../form/component/LabelInput'
import Input from '../../../form/component/Input'
import currentUserHasAccess from '../../../../util/widget-helper'
import { SUPPLIER_TRACKING_NUMBER_WIDGET } from '../../../process/ui-definition/process-ui'

const SupplierTrackingNumber = ({ readOnly, context, changeProcessContext, saveProcessContext, validationMessageList }) => {
    if (!currentUserHasAccess(SUPPLIER_TRACKING_NUMBER_WIDGET)) {
        return null
    }

    return (
        <ContentBox title="Supplier Tracking Number">
            <Row>
                <Column size={12}>
                    <ValidationMessageList validationMessageList={validationMessageList}/>
                </Column>
            </Row>
            <Row top="M">
                <Column size={6}>
                    <LabelInput label="TrackingNumber">
                        <Input
                            name="supplierTrackingNumber"
                            object={context}
                            onChange={changeProcessContext}
                            onBlur={saveProcessContext}
                        />
                    </LabelInput>
                </Column>
                <Column size={6}/>
            </Row>
        </ContentBox>
    )
}

SupplierTrackingNumber.propTypes = {
    readOnly: PropTypes.bool.isRequired,
    context: PropTypes.object.isRequired,
    changeProcessContext: PropTypes.func.isRequired,
    saveProcessContext: PropTypes.func.isRequired,
    validationMessageList: PropTypes.array.isRequired,
}

export default SupplierTrackingNumber



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/SupplierTrackingNumberWidget.js